module.exports = __webpack_public_path__ + "img/Patent_2.6a3f5d03.png";